export default "__VITE_ASSET__0c7f0ee0__"